{
  "id": "dark",
  "slug": "dark",
  "title": "الظلام",
  "title_fr": "Dark",
  "original_title": "Dark",
  "description": "اختفاء أطفال يكشف خيوطاً مزدوجة وأسراراً مؤلمة في بلدة ألمانية صغيرة.",
  "description_en": "A family saga with a supernatural twist set in a German town, where the disappearance of children exposes the relationships among four estranged families.",
  "description_fr": "Une saga familiale au tournant surnaturel, dans une ville allemande où la disparition d'enfants révèle les liens troubles entre quatre familles brouillées.",
  "year": 2017,
  "duration": "",
  "status": "مكتمل",
  "status_en": "Completed",
  "status_fr": "Terminée",
  "genres": [
    "Sci-Fi",
    "Thriller",
    "Mystery"
  ],
  "genres_ar": [
    "خيال علمي",
    "إثارة",
    "غموض"
  ],
  "genres_fr": [
    "Science-fiction",
    "Thriller",
    "Mystère"
  ],
  "rating": 8.7,
  "cast": [],
  "director": "",
  "poster": "https://image.tmdb.org/t/p/w500/apbrbWs8M9lyOpJYU5WXrpFbk1Z.jpg",
  "backdrop": "https://image.tmdb.org/t/p/w1280/apbrbWs8M9lyOpJYU5WXrpFbk1Z.jpg",
  "trailer_url": "https://www.youtube.com/watch?v=rrwycJ08PSA",
  "tags": [
    "time-travel",
    "mystery"
  ],
  "is_trending": true,
  "is_new": false,
  "paragraphs": [],
  "article": [
    {
      "id": "h-1",
      "type": "heading",
      "level": 2,
      "text": "لماذا يُعدّ Dark من أعظم مسلسلات الخيال العلمي؟",
      "text_en": "Why is Dark considered one of the greatest science fiction series?",
      "text_fr": "Pourquoi Dark est-elle considérée comme l'une des plus grandes séries de science-fiction ?"
    },
    {
      "id": "p-1",
      "type": "paragraph",
      "dropCap": true,
      "html": "في بلدة <b>فيندِن</b> الألمانية الصغيرة، يبدأ كل شيء باختفاء طفل... لكن سرعان ما يتكشّف أن الاختفاء ليس حدثاً معزولاً، بل حلقة في سلسلة معقّدة تمتد عبر <i>ثلاثة أجيال</i> وأربع عائلات متشابكة.",
      "html_en": "In the small German town of Wenden, it all begins with the disappearance of a child... but it soon becomes clear that the disappearance is not an isolated event, but rather a link in a complex chain that spans three generations and four intertwined families.",
      "html_fr": "Dans la petite ville allemande de Wenden, tout commence par la disparition d'un enfant… mais il apparaît rapidement que cette disparition n'est pas un événement isolé, mais plutôt un maillon d'une chaîne complexe qui s'étend sur trois générations et quatre familles étroitement liées."
    },
    {
      "id": "p-2",
      "type": "paragraph",
      "html": "كتب <b>باران بو أودار</b> و<b>يانتيه فريزه</b> هذا العمل بدقّة هندسية نادرة، حيث تترابط الخطوط الزمنية والشخصيات حتى آخر مشهد من الموسم الثالث.",
      "html_en": "Baran bo Odar and Jantje Friese wrote this work with rare geometric precision, where the timelines and characters are interconnected right up to the last scene of the third season.",
      "html_fr": "Baran bo Odar et Jantje Friese ont écrit cette œuvre avec une rare précision géométrique, où les chronologies et les personnages sont interconnectés jusqu'à la dernière scène de la troisième saison."
    },
    {
      "id": "h-2",
      "type": "heading",
      "level": 3,
      "text": "ما يميّز المسلسل",
      "text_en": "What distinguishes the series",
      "text_fr": "Ce qui distingue la série"
    },
    {
      "id": "l-1",
      "type": "list",
      "ordered": true,
      "items": [
        "بناء سردي معقّد لكنه مُحكم — كل تفصيل يخدم النهاية.",
        "تصوير سينمائي قاتم وأجواء غامرة تجعل الغابة شخصية بحد ذاتها.",
        "موسيقى تصويرية فريدة من <b>بن فروست</b> وأغنية مقدمة لا تُنسى.",
        "أداء استثنائي للممثلين في تجسيد الشخصيات عبر أعمار مختلفة."
      ],
      "items_en": [
        "A complex but tightly constructed narrative structure — every detail serves the ending.",
        "Dark cinematography and immersive atmosphere make the forest a character in itself.",
        "A unique soundtrack by <b>Ben Frost</b> and an unforgettable opening song.",
        "Exceptional performances by the actors in portraying characters across different ages."
      ],
      "items_fr": [
        "Une structure narrative complexe mais rigoureusement construite — chaque détail sert la fin.",
        "La cinématographie sombre et l'atmosphère immersive font de la forêt un personnage à part entière.",
        "Une bande originale unique composée par <b>Ben Frost</b> et une chanson d'ouverture inoubliable.",
        "Des prestations exceptionnelles de la part des acteurs, qui incarnent des personnages de différents âges."
      ]
    },
    {
      "id": "a-1",
      "type": "alert",
      "variant": "note",
      "title": "نصيحة قبل البدء",
      "html": "احرص على المشاهدة بصوت أصلي ألماني مع ترجمة — الدبلجة تُفقد العمل كثيراً من قوّته العاطفية.",
      "html_en": "Make sure to watch with original German audio and subtitles — dubbing diminishes much of the work's emotional power.",
      "title_en": "Advice before starting",
      "html_fr": "Veillez à regarder le film en version originale allemande avec sous-titres — le doublage diminue considérablement la puissance émotionnelle de l'œuvre.",
      "title_fr": "Conseils avant de commencer"
    },
    {
      "id": "q-1",
      "type": "quote",
      "html": "السؤال ليس متى... بل أين.",
      "author": "Jonas Kahnwald",
      "html_en": "The question is not when... but where.",
      "author_en": "Jonas Kahnwald",
      "html_fr": "La question n'est pas quand... mais où.",
      "author_fr": "Jonas Kahnwald"
    },
    {
      "id": "h-3",
      "type": "heading",
      "level": 3,
      "text": "هل المسلسل معقّد فعلاً؟",
      "text_en": "Is the series really that complicated?",
      "text_fr": "La série est-elle vraiment si compliquée ?"
    },
    {
      "id": "p-3",
      "type": "paragraph",
      "collapsible": true,
      "collapseTitle": "نصائح لمتابعة الخطوط الزمنية",
      "html": "نعم — يتنقّل المسلسل بين <b>1953</b> و<b>1986</b> و<b>2019</b> ثم <b>2052</b>، مع نسخ مختلفة العمر للشخصية ذاتها. أنصحك بـ:<br>• مشاهدة حلقتين متتاليتين على الأقل في كل جلسة.<br>• الاستعانة بشجرة عائلة المسلسل الرسمية بعد الموسم الأول.<br>• عدم تخطّي شارة المقدمة فهي تتغيّر مع تطوّر الأحداث.",
      "html_en": "Yes — the series jumps between 1953, 1986, 2019, and 2052, with different age versions of the same character. I recommend: • Watching at least two episodes in a row each time. • Consulting the official family tree after the first season. • Not skipping the opening credits, as they change as the story progresses.",
      "collapseTitle_en": "Tips for following timelines",
      "html_fr": "Yes — the series jumps between 1953, 1986, 2019, and 2052, with different age versions of the same character. I recommend: • Watching at least two episodes in a row each time. • Consulting the official family tree after the first season. • Not skipping the opening credits, as they change as the story progresses.",
      "collapseTitle_fr": "Conseils pour respecter les délais"
    },
    {
      "id": "a-2",
      "type": "alert",
      "variant": "warning",
      "title": "تنبيه",
      "html": "المسلسل غير مناسب للأطفال — يحتوي على مشاهد قاتمة ومواضيع نفسية ثقيلة.",
      "title_en": "alert",
      "html_en": "The series is not suitable for children — it contains dark scenes and heavy psychological themes.",
      "html_fr": "Cette série n'est pas adaptée aux enfants — elle contient des scènes sombres et des thèmes psychologiques difficiles.",
      "title_fr": "alerte"
    }
  ],
  "downloads": [],
  "seasons_count": 2
}